export enum InputType {
  AUTOCOMPLETE = 'autocomplete',
  CHECKBOX = 'checkbox',
  DATE_INPUT = 'dateInput',
  NUMBER_INPUT = 'numberInput',
  PART_AUTOCOMPLETE = 'partAutocomplete',
  PART_BOM_AUTOCOMPLETE = 'partBomAutocomplete',
  RADIO_GROUP = 'radioGroup',
  SELECT = 'select',
  SWITCH = 'switch',
  TEXT_EDITOR = 'textEditor',
  TEXT_INPUT = 'textInput',
  TEXTAREA = 'textarea',
}
